import { d as _extends } from './chunk-eb25cfa0.js';
import { forwardRef, createElement } from 'react';

function hoist(Comp, Base) {
  var Component = forwardRef(function (props, ref) {
    return (// @ts-ignore
      createElement(Comp, _extends({}, props, {
        elementRef: ref
      }))
    );
  });
  Component.uses = Base.uses;
  return Component;
}

export { hoist as a };
